import { useState, useEffect } from 'react'
import { supabase } from '../supabaseClient'

const roleLabel = r => (r === 'club_admin' ? 'Club admin' : 'Squad admin')

export default function ApproverNames() {
  const [people, setPeople] = useState(null)

  useEffect(() => {
    let cancelled = false
    supabase.rpc('get_my_approvers').then(({ data, error }) => {
      if (!cancelled) setPeople(error ? [] : (data || []))
    })
    return () => { cancelled = true }
  }, [])

  if (people === null) return null

  return (
    <div style={{ marginBottom: '24px' }}>
      {people.length > 0 && (
        <div style={{ background: '#f7f9fc', borderRadius: '10px', padding: '12px 16px', marginBottom: '16px', textAlign: 'left' }}>
          <div style={{ fontSize: '12px', color: '#888', marginBottom: '6px' }}>Who can approve you</div>
          {people.map((p, i) => (
            <div key={i} style={{ fontSize: '14px', color: '#333', padding: '3px 0' }}>
              <strong>{p.full_name || 'Admin'}</strong>
              <span style={{ color: '#888' }}> · {roleLabel(p.role)}{p.squad_name ? ' · ' + p.squad_name : ''}</span>
            </div>
          ))}
        </div>
      )}
      <p style={{ fontSize: '13px', color: '#888', lineHeight: '1.6', margin: 0 }}>
        Any problems? Contact us at info@gaamatchtracker.ie and we'll help.
      </p>
    </div>
  )
}
